<template>
  <div>
    <v-icon
      @click="onClickSummaryIcon(item)"
      :color="iconColor"
      class="mb-1"
      style="font-size: 20px; text-shadow: 0px 0px 3px rgb(26, 39, 46)"
      :class="{
        summaryIcon:
          clickedSummaryCard && clickedSummaryCard.topic === item.topic && clickedSummaryTimestamp === item.timestamps,
      }"
    >
      {{ 'mdi-bookmark' }}
    </v-icon>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  name: 'SummaryIcon',

  props: {
    seekTime: Number,
    iconColor: String,
    item: Object,
    modifiedSummaryData: Array,
  },
  data() {
    return {
      threshold: 0.5,
      styleRemoveTimeout: null,
    }
  },

  created() {},
  mounted() {
    // console.log('SummaryIcon mounted', this.modifiedSummaryData)
  },

  beforeDestroy() {},

  methods: {
    ...mapActions([
      'setClickedSummaryCard',
      'setClickedSummaryTimestamp',
      'setIsSummaryIconClicked',
      'setIsSummaryPlayOn',
      'setTimeStampSeekTime',
      'setIsRequestSetSeekTime',
      'setSeekTime',
      'setSeekTimeDecimal',
      'setSeeked',
    ]),

    isSummaryWithinRange(summaryTime, videoTime, threshold) {
      return Math.abs(summaryTime - videoTime) <= threshold
    },

    handleSegmentFound(summarySegment) {
      // console.log('summary hit with that time Mark', summarySegment)

      // if (this.styleRemoveTimeout) {
      //   clearTimeout(this.styleRemoveTimeout)
      // }

      this.setClickedSummaryCard(summarySegment)
      this.setClickedSummaryTimestamp(summarySegment.timestamps)

      // Set a new timeout to remove the styling after 2 seconds
      // if (this.isSummaryPlayOn) {
      //   this.styleRemoveTimeout = setTimeout(() => {
      //     this.removeIconStyling() // Replace this with your method to remove the styling
      //     this.styleRemoveTimeout = null
      //   }, 2000)
      // }
    },

    removeIconStyling() {
      // console.log('removeIconStyling')
      this.setClickedSummaryCard(null)
      this.setClickedSummaryTimestamp(null)
    },

    findSegmentByIndex(modifiedSummaryData, newTime) {
      const index = this.customBinarySearch(modifiedSummaryData, newTime)
      return index !== -1 ? modifiedSummaryData[index] : null
    },

    customBinarySearch(array, target) {
      let left = 0
      let right = array.length - 1

      while (left <= right) {
        const middle = Math.floor((left + right) / 2)
        const segment = array[middle]

        if (this.isSummaryWithinRange(segment.timestamps, target, this.threshold)) {
          return middle
        } else if (target < segment.timestamps) {
          right = middle - 1
        } else {
          left = middle + 1
        }
      }

      return -1
    },

    onClickSummaryIcon(item) {
      this.setIsSummaryIconClicked(item)
      this.setClickedSummaryCard(item)
      this.setSeekTimes(item.timestamps)
      this.setClickedSummaryTimestamp(item.timestamps)
    },

    setSeekTimes(time) {
      if (time > 0) {
        this.setTimeStampSeekTime(time)
        this.setIsRequestSetSeekTime(true)
      } else {
        this.setTimeStampSeekTime(0.062 / 1000)
        this.setIsRequestSetSeekTime(true)
      }

      // this.setSeekTime(time)
      // this.setSeekTimeDecimal(time)
      // this.setSeeked(0.0625)
    },
  },

  computed: {
    ...mapGetters([
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'commentList',
      'sectionIndex',
      'seekTimeDecimal',
      'clipIndex',
      'clipList',
      'chkMtPublic',
      'totalSectionList',
      'controlbarIconList',
      'currentClip',
      'currentMt',
      'selectedCh',
      'clickedSummaryCard',
      'clickedSummaryTimestamp',
      'currentClip',
      'isPauseIcon',
      'isSummaryPlayOn',
    ]),

    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
      isPlayerPause: (state) => {
        return state.clip.isPlayerPause
      },
    }),
  },

  watch: {
    // seekTime(val) {
    //   console.log('seekTime Watch 썸머리 아이콘', val)
    // },
    // isPauseIcon(bool) {
    //   // console.log('isPauseIcon', bool)
    //   this.setIsSummaryPlayOn(bool)
    // },
    // seekTimeDecimal(newTime) {
    //   if (!this.modifiedSummaryData) {
    //     return
    //   }
    //   const summarySegment = this.findSegmentByIndex(this.modifiedSummaryData, newTime)
    //   if (summarySegment && this.isSummaryPlayOn) {
    //     // console.log('summarySegment', this.isSummaryPlayOn)
    //     this.handleSegmentFound(summarySegment)
    //   }
    // },
  },
}
</script>

<style scoped>
.v-icon.v-icon::after {
  height: 0% !important;
}

.summaryIcon {
  animation: scaleUp 1s 1;
}

@keyframes scaleUp {
  0% {
    transform: scale(1.3);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>
